import { PeriodSelect } from '@/components/TaxReport/PeriodSelect';
import { MonthRangePicker } from '@/kit/DatePickers/MonthRangePicker';
import { ExportButton } from '@/components/TaxReport/ExportButton';
import { ReportFaqButton } from '@/components/TaxReport/ReportFaqButton';
import { Chips } from '@/components/TaxReport/Chips';
import s from './index.module.scss';

export const FilterViewDesktop = ({ params, setParams, onDateChange }) => {
  return (
    <div>
      <div className={s.header}>
        <div className={s.filters}>
          <PeriodSelect range={params.range} onChange={onDateChange} />
          <MonthRangePicker
            range={params.range}
            setRange={onDateChange}
            maxDate={new Date()}
          />
        </div>
        <div className={s.right}>
          <ExportButton />
          <ReportFaqButton />
        </div>
      </div>
      <Chips params={params} setParams={setParams} />
    </div>
  );
};
